
import React from "react";
import { Button, Modal } from 'react-bootstrap';
import {
    FaAngleDoubleRight, FaCodeBranch, FaDna, FaMicrochip,
} from 'react-icons/fa';

import Header from '../../ui/Header'

import Almacen from '../../../assets/img/almacen.jpg'
import Robotizado from '../../../assets/img/robotizado.jpg'
import Artificial from '../../../assets/img/artificial.jpg'

function Home() {

        return (
            <>
                <Header />

                <div className="CardGroup-OIP">

                    <h1>Automatización y Robótica</h1>

                    <div className="Cards-Robot-Left-Father" >
                        <div className="Cards-Robot" >
                            <div className="Robot-Position" >
                                <h2>Almacenes total o parcialmente<br /> automatizados</h2>
                                <FaCodeBranch className="Icons-IOP" />
                                <p>
                                    - Transelevadores / Transportadores
                                <br />- Shuttle / Mini-Load
                                <br />- Preparadores de Piciking Inteligentes
                            </p>
                            </div>
                            <img className="Automatication-Image-1" src={Almacen} alt="Almacen" />
                        </div>
                    </div>
                    <div className="Cards-Robot-Center-Father" >
                        <div className="Cards-Robot">
                            <div className="Robot-Position" >
                                <h2>Procesos total/parcialmente<br /> robotizado</h2>
                                <FaDna className="Icons-IOP" />
                                <p>
                                    - Traslado-AMR/AGV
                               <br />- Handling
                               <br />- Robótica Colaborativa
                            </p>
                            </div>
                            <img className="Automatication-Image-2" src={Robotizado} alt="Robot" />
                        </div>
                    </div>
                    <div className="Cards-Robot-Right-Father" >
                        <div className="Cards-Robot">
                            <div className="Robot-Position" >
                                <h2>Inteligencia artificial/visión<br /> artificial</h2>
                                <FaMicrochip className="Icons-IOP" />
                                <p>
                                    - Machine Learning
                                <br />- Redes Neuronales
                            </p>
                            </div>
                            <img className="Automatication-Image-3" src={Artificial} alt="InteligenciaArtificial" />
                        </div>
                    </div>
                </div>

                <div className="List-IOP">
                    <span className="Check-List"><FaAngleDoubleRight className="Check-Svg" />  Eficiencia </span>
                    <span className="Check-List"><FaAngleDoubleRight className="Check-Svg" />  Predictibilidad </span>
                    <span className="Check-List"><FaAngleDoubleRight className="Check-Svg" />  Reducción de costes </span>
                    <span className="Check-List"><FaAngleDoubleRight className="Check-Svg" />  Tiempos de servicio </span>
                    <span className="Check-List"><FaAngleDoubleRight className="Check-Svg" />  Escalabilidad </span>
                </div>
            </>
        );
    }
export default Home;